// "How did you hear about Bricks?" — keys match Dispatch backend/app/shared/applicant_source.py.
export const SOURCE_LABELS = {
  instagram: "Instagram",
  facebook: "Facebook",
  linkedin: "LinkedIn",
  tiktok: "TikTok",
  google: "Google search",
  indeed: "Indeed",
  craigslist_kijiji: "Craigslist/Kijiji",
  referral_photographer: "Referral from a photographer",
  referral_realtor: "Referral from a realtor/brokerage",
  event: "Event or meetup",
  other: "Other",
};

// "Instagram", "Other (podcast)", "Referral from a photographer (Sam Lee)". Empty for older applicants.
export function sourceLabel(source, detail) {
  const label = SOURCE_LABELS[String(source || "").trim().toLowerCase()];
  if (!label) return "";
  const text = String(detail || "").replace(/\s+/g, " ").trim();
  const showDetail = text && (source === "other" || String(source).startsWith("referral_"));
  return showDetail ? `${label} (${text})` : label;
}
